// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1w3nY","col":"Table_col__3h4l3","fulfillmentStatus":"Table_fulfillmentStatus__1l9R6","emailCol":"Table_emailCol__UyC1M"};